import React, { useState } from "react"
import {useTranslation} from "react-i18next"
import {useSnackbar} from "notistack"

// @ts-ignore
import FormSmallContainer from "../../../../../../../components/FormSmallContainer"
import {notifyForTmReject, submitTmReject, uploadTicketReviewProcessFiles} from "../../../../../../../api/ticketReviewProcess"
import OneTextFieldAndUploadForm, { OneTextFieldAndUploadFormFields } from "../../../../../../../forms/OneTextFieldAndUploadForm"
import { hasFilesForUpload } from "../../../../../../../util/file"
import ConfirmOrCancelPrompt from "../../../../../../../components/ConfirmOrCancelPrompt"
// @ts-ignore
import Dialog from "../../../../../../../components/Dialog"


interface TmRejectFormProps {
  toggleFormOpen: () => void,
  ticketId: string,
  projectId: string,
  ticketActionChange: (new_action_id: number) => void
}

export default function TmRejectForm(props: TmRejectFormProps) {
  const { t } = useTranslation("private")
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [submitValues, setSubmitValues] = useState<OneTextFieldAndUploadFormFields | null>(null)
  const [confirmOrCancelPromptOpen, setConfirmOrCancelPromptOpen] = useState<boolean>(false)

  const openConfirmCancelDialog = async (values: OneTextFieldAndUploadFormFields): Promise<void> => {
    setSubmitValues(values)
    setConfirmOrCancelPromptOpen(true)
  }
  
  const closeConfirmCancelDialog = () => {
    setConfirmOrCancelPromptOpen(false)
  }

  const submitForm = async (): Promise<void> => {
    closeConfirmCancelDialog()
    if(!!submitValues){
      try {
        const {data: trp} = await submitTmReject(props.ticketId, props.projectId, submitValues)
        // upload files
        if (hasFilesForUpload(submitValues.files)) {
          const uploadingKey = enqueueSnackbar('Uploading files...', {variant: 'info'})
          const fileUploadMessage = await uploadTicketReviewProcessFiles(submitValues.files, props.projectId, trp.id)
          closeSnackbar(uploadingKey)
          enqueueSnackbar(
            fileUploadMessage.message,
            {
              variant: fileUploadMessage.error ? 'error' : 'success',
              style: {whiteSpace: 'pre-wrap'}
            }
          )
        }
        // notify of the approval and create history object
        await notifyForTmReject(trp.id, props.projectId)
        if (trp?.new_action_id) {
          props.ticketActionChange(trp.new_action_id)
        }
        props.toggleFormOpen()
        enqueueSnackbar(t('view.Tickets.tm_reject_success'), {variant: "success"})
      } catch (_) {
        enqueueSnackbar(t('view.Tickets.tm_reject_fail'), {variant: "error"})
      }
    } else {
      enqueueSnackbar(t('view.Tickets.tm_reject_fail'), {variant: "error"})
    }
  }

  return (
    <>
      <FormSmallContainer>
        <OneTextFieldAndUploadForm
          onCancel={props.toggleFormOpen}
          submitForm={openConfirmCancelDialog}
          titleText={t('view.Tickets.tm_reject_title')}
          textFieldRequired={true}
          doNotClearOnSubmit={true}
        />
      </FormSmallContainer>
      <Dialog
        open={confirmOrCancelPromptOpen}
        onClose={closeConfirmCancelDialog}
        maxWidth={'sm'}
      >
        <ConfirmOrCancelPrompt 
          submitForm={submitForm} 
          closeDialog={closeConfirmCancelDialog} 
          dialogPrompt={t('view.Tickets.rejectPrompt')}
        />
      </Dialog>
    </>
  )
}
